import { Checkbox } from '@immo/ui-kit';
import { PROPERTY_CATEGORIES, type PropertyCategory } from '@immo/api-contract';
import { useTranslations } from '@/i18n/use-translations';

type Props = {
  readonly value: ReadonlyArray<PropertyCategory>;
  readonly onChange: (next: ReadonlyArray<PropertyCategory>) => void;
  readonly invalid?: boolean;
};

export function FactKeyCategoryPicker({ value, onChange, invalid = false }: Props) {
  const t = useTranslations('pages.admin.skills.fact-keys');
  const tCategory = useTranslations('common.immobilientyp.category');

  const toggle = (category: PropertyCategory, checked: boolean) =>
    onChange(PROPERTY_CATEGORIES.filter((each) => (each === category ? checked : value.includes(each))));

  return (
    <fieldset className="space-y-1 text-sm">
      <legend className="text-text-tertiary">{t('columns.categories')}</legend>
      <div className="flex flex-wrap gap-x-4 gap-y-2">
        {PROPERTY_CATEGORIES.map((category) => (
          <label key={category} className="inline-flex items-center gap-2">
            <Checkbox
              checked={value.includes(category)}
              invalid={invalid}
              onCheckedChange={(checked) => toggle(category, checked)}
            />
            {tCategory(category)}
          </label>
        ))}
      </div>
    </fieldset>
  );
}
